import React from 'react';
import styled from 'styled-components';

interface ToggleButtonProps {
  isOn: boolean;
  onClickToggle: () => void;
  disabled: boolean;
  isEdit: boolean;
}
const DesignServiceToggleButton = ({
  isOn,
  onClickToggle,
  disabled,
  isEdit,
}: ToggleButtonProps) => {
  return (
    <ToggleWrapper
      data-ison={isOn}
      onClick={onClickToggle}
      data-disabled={disabled}
    >
      <ToggleCircle data-ison={isOn} data-isedit={isEdit} />
      <ToggleLabel $ison={isOn} $isedit={isEdit}>
        {isOn ? 'On' : 'Off'}
      </ToggleLabel>
    </ToggleWrapper>
  );
};

export default DesignServiceToggleButton;

const ToggleWrapper = styled.button`
  position: relative;
  width: 73.6px;
  height: 34.1px;
  border-radius: 50px;
  border: none;
  cursor: pointer;
  background: #ff3445;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0 8px;
  transition: all 0.3s ease;
  &[data-ison='true'] {
    background: #6b97f8;
    justify-content: flex-end;
  }
  &[data-disabled='true'] {
    pointer-events: none;
    opacity: 0.5;
  }
`;

const ToggleCircle = styled.div`
  width: 20.3px;
  height: 20.3px;
  border-radius: 50%;
  background: #ffffff;
  position: absolute;
  transition: left 0.3s ease;
  left: 8px;
  &[data-ison='true'] {
    left: calc(100% - 28px);
    border: none;
  }
`;

interface ToggleLabelProps {
  $ison: boolean;
  $isedit: boolean;
}

const ToggleLabel = styled.span<ToggleLabelProps>`
  position: absolute;
  width: 100%;
  text-align: center;
  font-size: 18px;
  z-index: 1;
  left: 7.6px;
  color: white;
  left: ${({ $ison, $isedit }) => {
    if ($ison) return $isedit ? '-11px' : '-11px';
    return $isedit ? '10px' : '10px';
  }};
`;
